import { render, staticRenderFns } from "./AddonCard.vue?vue&type=template&id=c41cd930&scoped=true"
import script from "./AddonCard.vue?vue&type=script&lang=js"
export * from "./AddonCard.vue?vue&type=script&lang=js"
import style0 from "./AddonCard.vue?vue&type=style&index=0&id=c41cd930&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41cd930",
  null
  
)

export default component.exports